import { FC } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

export const InstructorLockedPageBanner: FC = () => (
  <Banner kind="info">{t("lock_status.instructor_lock_warning")}</Banner>
);
